// components/LeftNav.jsx
import React from "react";
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";
import logoWhite from "../assets/images/logo-white.png";
import { Image } from "react-bootstrap";


function LeftNav({ step }) {
  const navigate = useNavigate();

  const onGotoHome = () => {
    if (step === "success") {
      navigate('/');
    } else {
      Swal.fire({
        title: 'Are you sure want to go back?',
        text: 'You are about to navigate back to the home page. Please note that this will permanently remove your current conversations. Do you want to proceed?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, go back',
        cancelButtonText: 'Close'
      }).then((result) => {
        if (result.isConfirmed) {
          navigate('/');
        }
      });
    }
  }

  return (
    <div className="step-panel h-100">
      <button type="button" className="brand-row" onClick={onGotoHome}>
        <Image src={logoWhite} alt="Excellenc3" />
      </button>

      <div className="d-grid gap-2">
        <div className={`step ${step === "story" ? "active" : ""} ${["modules", "srs", "started", "success"].includes(step) ? "done" : ""}`}>
          <div className="dot">1</div>
          <div>
            <small>STEP 1</small>
            <strong>User Story</strong>
          </div>
        </div>

        {/* <div className={`step ${step === "modules" ? "active" : ""} ${["srs", "started", "success"].includes(step) ? "done" : ""}`}>
          <div className="dot">2</div>
          <div>
            <small>STEP 2</small>
            <strong>App Modules</strong>
          </div>
        </div> */}

        <div className={`step ${["srs", "started"].includes(step) ? "active" : ""} ${["success"].includes(step) ? "done" : ""}`}>
          <div className="dot">2</div>
          <div>
            <small>STEP 2</small>
            <strong>Preview SRS</strong>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LeftNav;